export const DATA_TYPE = {
	Appetite: "Appetite",
	Biomass: "Biomass",
	Dose: "Dose",
	FeedAmount: "FeedAmount",
	FishWeight: "FishWeight",
	HandFeedWeight: "HandFeedWeight",
	Intensity: "Intensity",
	Loadcell: "Loadcell",
	ManualAmount: "ManualAmount",
	Mean: "Mean",
	PelletCount: "PelletCount",
	PelletFishMinute: "PelletFishMinute",
	Planned: "Planned",
	Recommended: "Recommended",
	SFR: "SFR",
	SGR: "SGR",
	StandardAppetite: "StandardAppetite",
	Target: "Target",
	TodayAppetite: "TodayAppetite",
	TotalFeedWeight: "TotalFeedWeight",
	avgWeight: "avgWeight",
	blowerSpeed: "blowerSpeed",
	compass: "compass",
	conductivity: "conductivity",
	fcr: "fcr",
	feedStoreAmount: "feedStoreAmount",
	humidity: "humidity",
	latitude: "latitude",
	longitude: "longitude",
	pellet_count: "pellet_count",
	pressure: "pressure",
	pressurePipe: "pressurePipe",
	recommendedFeedWeight: "recommendedFeedWeight",
	runtime: "runtime",
	sal_conductivity: "sal_conductivity",
	sal_density: "sal_density",
	sal_sound_speed: "sal_sound_speed",
	sal_temp: "sal_temp",
	saturation: "saturation",
	sc_abs_tilt: "sc_abs_tilt",
	sc_heading: "sc_heading",
	sc_max_tilt: "sc_max_tilt",
	sc_sp_standard: "sc_sp_standard",
	sc_std_tilt: "sc_std_tilt",
	sc_strength: "sc_strength",
	sc_tilt_x: "sc_tilt_x",
	sc_tilt_y: "sc_tilt_y",
	sea_current_absolute_speed: "sea_current_absolute_speed",
	sea_current_direction: "sea_current_direction",
	sea_current_east: "sea_current_east",
	sea_current_north: "sea_current_north",
	sensor_depth: "sensor_depth",
	sgr: "sgr",
	smartSpreaderCycleTime: "smartSpreaderCycleTime",
	smartSpreaderCyclicMax: "smartSpreaderCyclicMax",
	smartSpreaderCyclicMin: "smartSpreaderCyclicMin",
	smartSpreaderManualSpeed: "smartSpreaderManualSpeed",
	targetRecommended: "targetRecommended",
	temperatureFeedingLine: "temperatureFeedingLine",
	water_oxygen_mg_l: "water_oxygen_mg_l",
	water_oxygen_percentage: "water_oxygen_percentage",
	water_oxygen_umol: "water_oxygen_umol",
	water_salinity: "water_salinity",
	water_temperature: "water_temperature",
	wind_direction: "wind_direction",
	wind_speed: "wind_speed",
} as const;

export const MEASUREMENT_UNIT = {
	"%": "%",
	kg: "kg",
	g: "g",
	"g/s": "g/s",
	g_per_s: "g_per_s",
	Tonne: "Tonne",
	pellet: "pellet",
	PFM: "PFM",
	Hz: "Hz",
	"°": "°",
	"mS/cm": "mS/cm",
	pellets: "pellets",
	"n/m3": "n/m3",
	Bar: "Bar",
	seconds: "seconds",
	"ms/cm": "ms/cm",
	"km/m3": "km/m3",
	"m/s": "m/s",
	"°C": "°C",
	"°/M": "°/M",
	"cm/s": "cm/s",
	dB: "dB",
	"°M": "°M",
	"Deg.M": "Deg.M",
	m: "m",
	Sec: "Sec",
	RPM: "RPM",
	"mg/L": "mg/L",
	"Mg/l": "Mg/l",
	umol: "umol",
	"μmol/l": "μmol/l",
	"umol/l": "umol/l",
	psu: "psu",
	ppt: "ppt",
	PSU: "PSU",
} as const;

export const DEPTH_SELECTION_OPTION = {
	option1: {
		id: "0-5m",
		min: 0,
		max: 5,
		measurementUnit: MEASUREMENT_UNIT.m,
	},
	option2: {
		id: "5-10m",
		min: 5,
		max: 10,
		measurementUnit: MEASUREMENT_UNIT.m,
	},
	option3: {
		id: "10-15m",
		min: 10,
		max: 15,
		measurementUnit: MEASUREMENT_UNIT.m,
	},
};

export const DATA_TYPE_MEASUREMENT_UNIT_MAP = {
	[DATA_TYPE.Appetite]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.Biomass]: [MEASUREMENT_UNIT.kg],
	[DATA_TYPE.Dose]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.FeedAmount]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.FishWeight]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.HandFeedWeight]: [MEASUREMENT_UNIT.kg],
	[DATA_TYPE.Intensity]: [MEASUREMENT_UNIT["g/s"], MEASUREMENT_UNIT.g_per_s],
	[DATA_TYPE.Loadcell]: [MEASUREMENT_UNIT.Tonne],
	[DATA_TYPE.ManualAmount]: [MEASUREMENT_UNIT.g, MEASUREMENT_UNIT.kg],
	[DATA_TYPE.Mean]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.PelletCount]: [MEASUREMENT_UNIT.pellet],
	[DATA_TYPE.PelletFishMinute]: [MEASUREMENT_UNIT.PFM],
	[DATA_TYPE.Planned]: [MEASUREMENT_UNIT.kg],
	[DATA_TYPE.Recommended]: [MEASUREMENT_UNIT.kg],
	[DATA_TYPE.SFR]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.SGR]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.StandardAppetite]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.Target]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.TodayAppetite]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.TotalFeedWeight]: [MEASUREMENT_UNIT.kg, MEASUREMENT_UNIT.g],
	[DATA_TYPE.avgWeight]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.blowerSpeed]: [MEASUREMENT_UNIT.Hz],
	[DATA_TYPE.compass]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.conductivity]: [MEASUREMENT_UNIT["mS/cm"]],
	[DATA_TYPE.fcr]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.feedStoreAmount]: [MEASUREMENT_UNIT.g, MEASUREMENT_UNIT.kg],
	[DATA_TYPE.humidity]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.latitude]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.longitude]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.pellet_count]: [MEASUREMENT_UNIT.pellets],
	[DATA_TYPE.pressure]: [MEASUREMENT_UNIT["n/m3"]],
	[DATA_TYPE.pressurePipe]: [MEASUREMENT_UNIT.Bar],
	[DATA_TYPE.recommendedFeedWeight]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.runtime]: [MEASUREMENT_UNIT.seconds],
	[DATA_TYPE.sal_conductivity]: [MEASUREMENT_UNIT["ms/cm"]],
	[DATA_TYPE.sal_density]: [MEASUREMENT_UNIT["km/m3"]],
	[DATA_TYPE.sal_sound_speed]: [MEASUREMENT_UNIT["m/s"]],
	[DATA_TYPE.sal_temp]: [MEASUREMENT_UNIT["°C"]],
	[DATA_TYPE.saturation]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.sc_abs_tilt]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.sc_heading]: [MEASUREMENT_UNIT["°/M"]],
	[DATA_TYPE.sc_max_tilt]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.sc_sp_standard]: [MEASUREMENT_UNIT["cm/s"]],
	[DATA_TYPE.sc_std_tilt]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.sc_strength]: [MEASUREMENT_UNIT.dB],
	[DATA_TYPE.sc_tilt_x]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.sc_tilt_y]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.sea_current_absolute_speed]: [MEASUREMENT_UNIT["cm/s"]],
	[DATA_TYPE.sea_current_direction]: [
		MEASUREMENT_UNIT["°M"],
		MEASUREMENT_UNIT["°/M"],
		MEASUREMENT_UNIT["Deg.M"],
	],
	[DATA_TYPE.sea_current_east]: [MEASUREMENT_UNIT["cm/s"]],
	[DATA_TYPE.sea_current_north]: [MEASUREMENT_UNIT["cm/s"]],
	[DATA_TYPE.sensor_depth]: [MEASUREMENT_UNIT.m],
	[DATA_TYPE.sgr]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.smartSpreaderCycleTime]: [MEASUREMENT_UNIT.Sec],
	[DATA_TYPE.smartSpreaderCyclicMax]: [MEASUREMENT_UNIT.RPM],
	[DATA_TYPE.smartSpreaderCyclicMin]: [MEASUREMENT_UNIT.RPM],
	[DATA_TYPE.smartSpreaderManualSpeed]: [MEASUREMENT_UNIT.RPM],
	[DATA_TYPE.targetRecommended]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.temperatureFeedingLine]: [MEASUREMENT_UNIT["°C"]],
	[DATA_TYPE.water_oxygen_mg_l]: [MEASUREMENT_UNIT["mg/L"], MEASUREMENT_UNIT["Mg/l"]],
	[DATA_TYPE.water_oxygen_percentage]: [MEASUREMENT_UNIT["%"], MEASUREMENT_UNIT["Mg/l"]],
	[DATA_TYPE.water_oxygen_umol]: [
		MEASUREMENT_UNIT.umol,
		MEASUREMENT_UNIT["μmol/l"],
		MEASUREMENT_UNIT["umol/l"],
	],
	[DATA_TYPE.water_salinity]: [MEASUREMENT_UNIT.psu, MEASUREMENT_UNIT.ppt, MEASUREMENT_UNIT.PSU],
	[DATA_TYPE.water_temperature]: [MEASUREMENT_UNIT["°C"]],
	[DATA_TYPE.wind_direction]: [MEASUREMENT_UNIT["Deg.M"]],
	[DATA_TYPE.wind_speed]: [MEASUREMENT_UNIT["cm/s"]],
} as const;

export const DATE_FORMAT = {
	DATE_TIME: "FORMAT:date.date_time",
	DATE_HOURS: "FORMAT:date.date_hours",
	WEEKDAY_DATE_SHORT_MONTH_YEAR: "FORMAT:date.weekday_date_short_month_year",
	DATE: "FORMAT:date.date",
	TIME: "FORMAT:date.time",
	DAY_MONTH: "FORMAT:date.day_month",
} as const;

export const DURATION_FORMAT = {
	HOURS_MINUTES: "FORMAT:duration-fmt.hours-minutes",
	HOURS_MINUTES_SECONDS: "FORMAT:duration-fmt.hours-minutes-seconds",
	DAYS_HOURS_MINUTES_SECONDS: "FORMAT:duration-fmt.days-hours-minutes-seconds",
	DAYS_HOURS_MINUTES: "FORMAT:duration-fmt.days-hours-minutes",
	HOURS: "FORMAT:duration-fmt.hours",
} as const;

export const UNIT_FORMAT = {
	GRAM: "FORMAT:unit.g",
	KILOGRAM: "FORMAT:unit.kg",
	TONS: "FORMAT:unit.tn",
	PERCENT: "FORMAT:unit.percent",
	KILOGRAM_PER_MINUTE: "FORMAT:unit.kg/m",
	AS_GRAM: "FORMAT:unit.as_g",
	TEMPERATURE: "FORMAT:unit.temperature",
	PSU: "FORMAT:unit.PSU",
	LENGTH: "FORMAT:unit.length",
	UNITLESS: "FORMAT:unit.noUnit",
	UMOL: "FORMAT:unit.umol",
	MG_L: "FORMAT:unit.mg/l",
	M_S: "FORMAT:unit.m/s",
	RPM: "FORMAT:unit.rpm",
	HZ: "FORMAT:unit.hz",
	BAR: "FORMAT:unit.bar",
	SECONDS: "FORMAT:unit.seconds",
	DEGREES: "FORMAT:unit.degrees",
	CM_S: "FORMAT:unit.cm/s",
	KM_M3: "FORMAT:unit.km/m3",
	N_M3: "FORMAT:unit.n/m3",
	PFM: "FORMAT:unit.pfm",
	PELLETS: "FORMAT:unit.pellets",
} as const;

export const MEASUREMENT_UNITS = Object.values(MEASUREMENT_UNIT);
export const DATA_TYPES = Object.values(DATA_TYPE);
export const DEPTH_SELECTION_OPTIONS = Object.values(DEPTH_SELECTION_OPTION);
